import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Button: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: '400',
    px: '16px',
    height: '40px',
    rounded: '4px',
    cursor: 'pointer',
    _disabled: {
      opacity: 1,
      _active: {
        color: 'gray.700',
        bg: 'gray.100',
        shadow: 'none',
      },
    },
  },
  variants: {
    solid: {
      bg: 'brand.500',
      border: '0',
      color: 'white ',
      _hover: {
        color: '#3F2CA1',
        bg: 'brand.200',
      },
      _active: {
        color: '#3F2CA1',
        bg: 'brand.200',
        shadow: '0px 0px 7px rgba(184, 175, 233, 0.8)',
      },
      _disabled: {
        color: 'gray.700',
        bg: 'gray.100',
        _hover: {
          color: 'gray.700',
          bg: 'gray.100',
        },
      },
    },
    outline: {
      // _hover: {
      //   bg: 'success.50',
      //   color: 'success.500',
      // },
      // cursor: 'not-allowed',
      _active: {
        // shadow: '0px 0px 7px rgba(41, 204, 151, 0.4)',
      },
      _disabled: {
        color: 'gray.700',
        bg: 'gray.100',
        borderColor: 'gray.300',
        _hover: { bg: 'gray.100 !important', color: 'gray.700 !important' },
      },
    },
    gray: {
      bg: 'gray.200',
      _hover: { bg: 'gray.300' },
    },
    unstyled: {
      color: 'gray.700',
      bg: 'none',
      border: '0',
      padding: 'auto',
      _hover: {
        color: 'brand.300',
      },
      _disabled: {
        color: 'gray.700 !important',
      },
    },
  },
  sizes: {
    sm: {
      fontSize: '13px',
      h: '32px',
    },
    md: {
      fontSize: '14px',
      h: '40px',
    },
    lg: {
      fontSize: '14px',
      h: '56px',
    },
  },
  defaultProps: {
    size: 'md',
  },
};

export default Button;
